/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {
    import EntityQuery = breeze.EntityQuery;

    export class ProcessTypeService extends services.DataService<Wars.Domain.Model.ProcessType> {

        constructor(
            injectedBreeze: typeof breeze,
            $q: angular.IQService,
            private $http: angular.IHttpService,
            private processSubTypeService: services.ProcessSubTypeService) {
            super(injectedBreeze, $q);
      }

        public getActiveProcessTypesNonBreeze(): ng.IPromise<any> {
          var d = this.$q.defer();

          this.$http.get('./api/ProcessType/ActiveProcessTypes').then(r => {
            d.resolve(r.data);
          });

          return d.promise;
      }

        public getExecutionProcessTypes(): ng.IPromise<Wars.Domain.Model.Dtos.ProcessTypeDto[]> {
            var d = this.$q.defer();

            this.$http.get('./api/ProcessType').then(r => {
                d.resolve(r.data);
            });

            return d.promise;
        }

        public getExecutionProcessType(id:string): ng.IPromise<Wars.Domain.Model.Dtos.ProcessTypeDto> {
            var d = this.$q.defer();

            this.$http.get('./api/ProcessType/'+id).then(r => {
                d.resolve(r.data);
            });

            return d.promise;
        }

        public getActiveProcessTypes(): ng.IPromise<Wars.Domain.Model.ProcessType[]> {
            var defer = this.$q.defer();

            const query = this.breezeModule.EntityQuery
                .from("ProcessTypes")
                .expand("processConfigurations")
                .orderBy("name");

            this.executeQuery(query).then((processTypes) => {
                var activeProcessTypes = [];
                for (var i = 0; i < processTypes.length; i++) {
                    var currentProcessType = processTypes[i];
                    if (Enumerable.from(currentProcessType.processConfigurations).any(x => x.minorVersion != null && x.configurationStatus === Wars.Domain.Model.Codes.Enums.ConfigurationStatus.Active)) {
                        activeProcessTypes.push(currentProcessType);
                    }
                }
                defer.resolve(activeProcessTypes);
            });

            return defer.promise;
        }

        public getChildProcessTypes(): ng.IPromise<Wars.Domain.Model.ProcessType[]> {
            var predicate = new this.breezeModule.Predicate("isChildProcess", "==", true)
                .and("isEmbedded", "==", false);

            const query = this.breezeModule.EntityQuery
                .from("ProcessTypes")
                .where(predicate)
                .orderBy("name");

            return this.executeQuery(query);
        }


        public getConfigurationChildProcesses(configurationId): ng.IPromise<Wars.Domain.Model.ProcessType[]> {
            var d = this.$q.defer();

            let query = this.breezeModule.EntityQuery
                .from("ChildProcesses");

            query = query.where("processConfiguration_id", "==", configurationId);

            query = query.expand("processType.processConfigurations")
                .orderBy("processType.name");

            this.executeQuery(query).then(result => {
                var processTypes: Wars.Domain.Model.ProcessType[] = [];

                result.forEach(childProcess => {
                    processTypes.push((<Wars.Domain.Model.ChildProcess>(<any>childProcess)).processType);
                });

                d.resolve(processTypes);
            });

            return d.promise;
        }

        public getAllProcessTypes(): ng.IPromise<Wars.Domain.Model.ProcessType[]> {
            let query = this.breezeModule.EntityQuery
                .from("ProcessTypes");

            query = query.where("isEmbedded", "==", false);

            query = query.expand("processConfigurations")
                .orderBy("name");

            return this.executeQuery(query);
        }

        public getProcessTypeById(id: string): ng.IPromise<Wars.Domain.Model.ProcessType> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessTypes")
                .where("id", "==", id);

            return this.fetch(query);
        }

        public copyProcessType(id: string): ng.IPromise<boolean> {
            var handlerUrl = "api/ProcessType/" + id + "/Copy";

            var result: ng.IPromise<any> = this.$http.post(handlerUrl, undefined)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, undefined));

            return result;
        }

        public createProcessConfiguration(processType: Wars.Domain.Model.ProcessType): Wars.Domain.Model.ProcessConfiguration {
            var processConfig = this.createNewEntity<Wars.Domain.Model.ProcessConfiguration>("ProcessConfiguration", { myProcessType: processType });
            var statusCodeGroup = this.createNewEntity<Wars.Domain.Model.Statuses.StatusCodeGroup>("StatusCodeGroup");

            statusCodeGroup.processConfiguration_id = processConfig.id;
            statusCodeGroup.shortDescription = "Process Level Status Group";

            processConfig.myStatusCodeGroup = statusCodeGroup;
            processConfig.statusCodeGroup_id = statusCodeGroup.id;

            var processInitiatorClaim = this.createProcessInitiatorProcessClaimDefinition();
            processConfig.myClaims.push(processInitiatorClaim);
            processInitiatorClaim.processConfiguration_id = processConfig.id;

            this.processSubTypeService.createConfig(processConfig);
            this.createInitialStatusAndState(processConfig);

            return processConfig;
        }

        private createInitialStatusAndState(processConfig: Wars.Domain.Model.ProcessConfiguration): void {
            var newStatus = this.createNewEntity<Wars.Domain.Model.Statuses.StatusCode>("StatusCode");
            newStatus.uniqueIdentifier = UtilityService.generateGuidComb();
            newStatus.isInitialStatus = true;
            newStatus.isSystemLevel = false;
            newStatus.shortDescription = "Initial Status";
            newStatus.myParentStatusGroup = processConfig.myStatusCodeGroup;
            newStatus.parentStatusCodeGroup_id = processConfig.statusCodeGroup_id;

            var newState = this.createNewEntity<Wars.Domain.Model.Statuses.StateCode>("StateCode");
            newState.uniqueIdentifier = UtilityService.generateGuidComb();
            newState.isInitialState = true;
            newState.isSystemLevel = false;
            newState.shortDescription = "Initial State";
            newState.myParentStatus = newStatus;
            newState.statusCode_id = newStatus.id;
            newStatus.myStates.push(newState);

            var stateInfo = this.createNewEntity<Wars.Domain.Model.Workflow.InfoEntities.StateInfo>("StateInfo");
            stateInfo.myStateCode = newState;
            stateInfo.stateCode_id = newState.id;

            var stateWorkflowBlock = this.createNewEntity<Wars.Domain.Model.Workflow.Blocks.StateWorkflowBlock>("StateWorkflowBlock");
            stateWorkflowBlock.blockType = Wars.Domain.Model.Codes.Enums.BlockType.State;
            stateWorkflowBlock.name = "Initial State";
            stateWorkflowBlock.uniqueIdentifier = UtilityService.generateGuidComb();
            stateWorkflowBlock.isInitialWorkflowBlock = true;
            stateWorkflowBlock.myStatus = newStatus;
            stateWorkflowBlock.statusCode_id = newStatus.id;
            stateWorkflowBlock.stateInfo_id = stateInfo.id;
            stateWorkflowBlock.myStateInfo = stateInfo;

            newState.stateWorkflowBlockId = stateWorkflowBlock.id;
            newStatus.myWorkflowBlocks.push(stateWorkflowBlock);

            processConfig.myStatusCodeGroup.myStatuses.push(newStatus);
        }

        private createProcessInitiatorProcessClaimDefinition(): Wars.Domain.Model.ClaimDefinition {
            var claimDefinition = this.createNewEntity<Wars.Domain.Model.ClaimDefinition>("ClaimDefinition");
            claimDefinition.specialClaimTagType = Wars.Domain.Model.Codes.Enums.SpecialClaimTag.ProcessInitiator;
            claimDefinition.maxAssignments = 1;
            claimDefinition.type = "Process Initiator";
            claimDefinition.valueAssignable = false;
            claimDefinition.valueType = Wars.Domain.Model.Codes.Enums.VariableType.None;
            claimDefinition.uniqueIdentifier = "89877FB0-0816-4263-947D-0159B7CC7AD2";
            return claimDefinition;
        }

        public createProcessType(): Wars.Domain.Model.ProcessType {
            return this.createNewEntity<Wars.Domain.Model.ProcessType>("ProcessType");
        }
        public createChildProcess(): Wars.Domain.Model.ChildProcess {
            return this.createNewEntity<Wars.Domain.Model.ChildProcess>("ChildProcess");
        }

        public getByIdEagerLoadAppConfigs(processTypeId: string): ng.IPromise<Wars.Domain.Model.ProcessType> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessTypes")
                .where("id", "==", processTypeId)
                .expand("processConfigurations");

            return this.fetch(query);
        }

        public getActiveProcessTypeAndSecurity(id: string): ng.IPromise<Wars.Domain.Model.ProcessType> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessTypes")
                .expand("processConfigurations, processConfigurations.mySecurityMatrices")
                .where("id", "==", id)
                .orderBy("name");

            return this.fetch(query);
        }
    }
}

warsApp.registerService('ProcessTypeService', ['breeze', '$q', '$http', "processSubTypeService"]);